import { render, staticRenderFns } from "./AdminSearches.vue?vue&type=template&id=2c2ee1de"
import script from "./AdminSearches.vue?vue&type=script&lang=js"
export * from "./AdminSearches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports